import React from "react";
import { formatDistanceToNow, isPast } from "date-fns";
import { Link, TextWithStatus } from "@sscs/ui";
import { DownloadIcon as MUIFileDownloadOutlinedIcon } from "@sscs/ui/icons";
import { ExportJobStatus } from "Types";
import styles from "./exportsTable.module.scss";

type ExportJobDownloadLinkProps = {
  label: string;
  status: ExportJobStatus;
  download_url: string | null;
  expires_at: string | null;
};

export const ExportJobDownloadLink = ({
  label,
  status,
  download_url,
  expires_at,
}: ExportJobDownloadLinkProps): React.JSX.Element | undefined => {
  switch (status) {
    case "DONE":
      if (download_url && expires_at && !isPast(expires_at)) {
        return (
          <TextWithStatus
            text={
              <Link
                href={download_url}
                className={styles["download-link"]}
                underline="none"
              >
                <MUIFileDownloadOutlinedIcon />
                {label}
              </Link>
            }
          >
            {`Expires in ${formatDistanceToNow(expires_at)}`}
          </TextWithStatus>
        );
      } else if (expires_at && isPast(expires_at)) {
        return <span>Expired</span>;
      }
      return <span>Something went wrong</span>;
    case "FAILED":
      return <span>Failed to create an export</span>;
    case "IN_PROGRESS":
      return <span>Download link will appear here once ready</span>;
    case "NOT_SELECTED":
      return <span>Not selected</span>;
  }
};

export default ExportJobDownloadLink;
